// TODO(RBAC, parent #641 #647): admin only
import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { createConnectQueryKey, useQuery } from '@connectrpc/connect-query'
import {
  createWorkflowAutoCreationRules,
  deleteWorkflowAutoCreationRule,
  listWorkflowAutoCreationRules,
  updateWorkflowAutoCreationRule,
} from '@ebalance/proto/bffuser/v1/workflow_auto_creation_rule_service-WorkflowAutoCreationRuleService_connectquery'
import {
  ListWorkflowAutoCreationRulesRequestSchema,
  type ListWorkflowAutoCreationRulesResponse,
} from '@ebalance/proto/bffuser/v1/workflow_auto_creation_rule_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

const listKey = createConnectQueryKey({
  schema: listWorkflowAutoCreationRules,
  cardinality: 'finite',
})

export function useListWorkflowAutoCreationRules(options: {
  throwOnError: boolean
}): UseQueryResult<ListWorkflowAutoCreationRulesResponse, ConnectError> {
  return useQuery(
    listWorkflowAutoCreationRules,
    create(ListWorkflowAutoCreationRulesRequestSchema, {}),
    { throwOnError: options.throwOnError },
  )
}

// 雛形・エリアを変えた Update は新しい id を返す (#12431) ので、
// cache を patch せず一覧を取り直す。
export function useCreateWorkflowAutoCreationRules(): InvalidatingMutationResultFor<
  typeof createWorkflowAutoCreationRules
> {
  return useInvalidatingMutation(createWorkflowAutoCreationRules, [listKey])
}

export function useUpdateWorkflowAutoCreationRule(): InvalidatingMutationResultFor<
  typeof updateWorkflowAutoCreationRule
> {
  return useInvalidatingMutation(updateWorkflowAutoCreationRule, [listKey])
}

export function useDeleteWorkflowAutoCreationRule(): InvalidatingMutationResultFor<
  typeof deleteWorkflowAutoCreationRule
> {
  return useInvalidatingMutation(deleteWorkflowAutoCreationRule, [listKey])
}
